import * as React from "react";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { TreeList } from "../../Common/TreeList/Index";
import { IExtractList } from "./redux/Types";
import ExtractTreeListItem from "./ExtractTreeListItem.logic";
import "./Style.scss";

interface IExtractTreeList {
  extractList: IExtractList[];
  handleOnClickItem: (item: IExtractList) => void;
}

/**
 * Responsible for rendering the Extract Table
 */
export const ExtractTreeListView: React.FC<IExtractTreeList> = (props: IExtractTreeList) => {
  const { t: translate } = useTranslation();
  const { extractList, handleOnClickItem } = props;


  const getListItems = (): JSX.Element[] => {
    return extractList.map((item: IExtractList, index: number) =>
      <ExtractTreeListItem key={"extract-item-" + index} item={item} handleOnClickItem={handleOnClickItem} />);
  };

  return (
    <>
      {extractList.length > 0 ?
        <TreeList id="extract-list" data-testid="extract-list" className="ebt-extract-treelist">
          {getListItems()}
        </TreeList>
        :
        <div id="no-extract-list" data-testid="no-extract-list" className="ebt-extract-search">
          {translate("Search.EmptyExtract")}
        </div>
      }
    </>
  );
};

export default ExtractTreeListView;
